import React, { useRef } from "react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import { actors } from "../mock";

export default function ActorsRow() {
  const ref = useRef(null);
  const scroll = (dir) => ref.current?.scrollBy({ left: dir * 600, behavior: "smooth" });

  return (
    <section className="max-w-[1500px] mx-auto px-6 mt-14">
      <div className="flex items-end justify-between mb-3">
        <div className="flex items-start gap-2">
          <Star className="w-6 h-6 text-yellow-400" />
          <div>
            <h2 className="text-2xl md:text-3xl font-bold tracking-tight">Atores e Atrizes</h2>
            <p className="text-red-500/85 mt-0.5 text-sm">Os maiores talentos da telona, todos reunidos no Uniplay.</p>
          </div>
        </div>
        <div className="hidden md:flex gap-2">
          <button onClick={() => scroll(-1)} className="w-9 h-9 rounded-full bg-white/5 hover:bg-yellow-500/30 transition border border-white/10 flex items-center justify-center">
            <ChevronLeft className="w-5 h-5 text-white" />
          </button>
          <button onClick={() => scroll(1)} className="w-9 h-9 rounded-full bg-white/5 hover:bg-yellow-500/30 transition border border-white/10 flex items-center justify-center">
            <ChevronRight className="w-5 h-5 text-white" />
          </button>
        </div>
      </div>

      <div ref={ref} className="no-scrollbar flex gap-4 overflow-x-auto pb-6 -mx-2 px-2">
        {actors.map((name) => {
          const initials = name.split(" ").slice(0, 2).map((n) => n[0]).join("");
          const url = `https://uniplay.com.br/actors/${encodeURIComponent(name)}.png`;
          return (
            <div key={name} className="shrink-0 w-[120px] flex flex-col items-center gap-2 group cursor-pointer">
              <div className="relative w-[110px] h-[110px] rounded-full overflow-hidden bg-gradient-to-br from-red-600/30 to-red-700/30 flex items-center justify-center text-white text-2xl font-bold border-2 border-white/10 group-hover:border-red-600 transition">
                <span className="absolute">{initials}</span>
                <img
                  src={url}
                  alt={name}
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  className="relative w-full h-full object-cover"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
              </div>
              <p className="text-xs text-white/80 text-center font-medium leading-tight group-hover:text-red-500 transition">{name}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
